// ================================
// API Endpoints
// ================================

const CUSTOMER = "/customer";

// Employee-related endpoints
const employee = {
  getEmployees: "/employee",
};

// Task-related endpoints
const task = {
  report: "/reportingTable",
  bestPerformer: "/task/best/performer",
  breachAnalysis: "/task/breach/analysis",
  cummulativeAnalysis: "/task/cumulative/analysis",
  taskAnalyticsReport: "/task/report/analytics",
  taskComment: (id) => `/task/comment/deskstatus/${id}`,
  holdForThisMonth: (id) => `/task/hold/${id}`,
  reassignTaskFilterList: `/task/getReassignTaskFilterList`
};

// Central task management endpoints
const centralTask = {
  getAllTasks: "/product/tasks",
  createTask: "/product/createTask",
  updateTaskById: (id) => `/product/updateTask/${id}`,
  deleteTaskById: (id) => `/product/deleteTask/${id}`,
};

// Customer-related endpoints
const customer = {
  delayAnalysis: `${CUSTOMER}/delayAnalysis`,
  all: `${CUSTOMER}/customerInfo/all`,
};

// Leave management endpoints
const leave = {
  getLeaves: "/leave",
};

// Desk & Email management endpoints
const deskEmails = {
  getDeskDashboard: "/deskmanagement/deskDashboard",
  getMetrics: "/deskmanagement/deskDashboard/metrics",
  getDeskEmailList: "/emailprocessing/all",
  getByEmailListId: (id) => `/emailprocessing/${id}`,
  getAssetList: (id) => `/task/asset/${id}`,
  docAssetMapping: "/task/documentAssetMapping",
  assetUnMapping: "/task/documentAssetUnMapping",
  getDocumentView: (id) => `/emailprocessing/documentview/${id}`,
  closeDeskById: (id) => `/emailprocessing/status/${id}`,
  updateDeskCustomer: (id) => `/emailprocessing/customermapping/${id}`,
  familyName: (email) => `/emailprocessing/familyname?email=${email}`,
  rejection: "/emailprocessing/emaildocument/rejection",
  updateDocumentName: (id) => `emailprocessing/renameDocument/${id}`,
  createTemplate: "/emailConfig/createTemplate",
  getTemplate: "/emailConfig/getTemplate",
  deleteTemplate: (id) => `/emailConfig/deleteTemplate/${id}`,
  updateTemplate: (id) => `/emailConfig/updateTemplate/${id}`,
  sentTemplateMail: "/emailConfig/sentTemplateMail",
};

// Product-related endpoints
const product = {
  getAllProducts: "/product/productList",
  createProduct: "/product/onboard",
  updateProductById: (id) => `/product/onboard/${id}`,
  deleteProductById: (id) => `/product/${id}`,
  getProductById: (id) => `/product/${id}`,
  deleteProductDocument: (id) => `/product/document/${id}`,
  deleteProductTaskDocument: (id) => `/product/task/document/${id}`,
  exportProductDetails: "/product/productList/download-xlsx"
};

const client ={
  getClientsById: (id) => `/product/onboarding-progress/${id}`,
  onboardClient: "/product/clientMapping",
  getClientDetails: '/product/family/onboarding-progress',
  getClientOnboardingProgress: (clientId) => `/product/family/client-onboarding-progress/${clientId}`,
  addTaskDetails: '/product/client-task/upload-document',
  getTaskDetailsByTaskId: (id) => `/product/clientTaskProgress/${id}`,
  deleteClientById: '/product/delete-client-mappings',
  deleteTaskDocumentsById : (id) => `/product/client-task/document/${id}`,
  completeOnboarding: '/product/client/update-status'
};

const common ={
  getFamilyList: "/product/clientName/Member",
  getSignedUrl: "/getsignedUrl",
}
export { employee, customer, task, leave, deskEmails, centralTask, product, client ,common};  